/* Aurelliani core: scroll reveal, back-to-top, recently viewed tracker. */
(function () {
  'use strict';

  /* ---------- scroll reveal (.au-reveal -> .is-in) ---------- */
  var io = null;
  function watch(root) {
    var els = (root || document).querySelectorAll('.au-reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) { io.observe(el); });
  }
  window.AuReveal = { watch: watch };

  /* Horizon 4 scrolls inside .page-wrapper on desktop (html/body are overflow:hidden from
     990px), so window.scrollY stays 0 there; read and move whichever element scrolls. */
  var scroller = function () { var pw = document.querySelector('.page-wrapper'); return pw && /(auto|scroll)/.test(getComputedStyle(pw).overflowY) ? pw : null; };
  function scrollTop() { var s = scroller(); return s ? s.scrollTop : window.scrollY; }
  window.AU_SCROLL = { el: scroller, y: scrollTop };

  /* ---------- phone menu: hand focus back to the button that opened it (was a patch in
     header-drawer.js); only when focus is lost or still inside the closed drawer ---------- */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!(d instanceof HTMLDetailsElement) || d.open || !d.closest('header-drawer')) return;
    var summary = d.querySelector(':scope > summary');
    setTimeout(function () {
      var a = document.activeElement;
      if (summary && (!a || a === document.body || d.contains(a))) summary.focus({ preventScroll: true });
    }, 450);
  }, true);

  /* ---------- drawers: tap the dimmed page to close (desktop overlay, see au-design) ---------- */
  document.addEventListener('pointerdown', function (e) {
    var pw = document.querySelector('.page-wrapper--drawer-open');
    if (!pw || !pw.contains(e.target)) return;
    document.querySelectorAll('theme-drawer').forEach(function (d) {
      if (d.isOpen && typeof d.close === 'function') d.close();
    });
  }, true);

  /* ---------- back to top ---------- */
  function backToTop() {
    if (document.querySelector('.au-top')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'au-top';
    b.setAttribute('aria-label', 'Back to top');
    b.innerHTML = '<svg viewBox="0 0 20 20" width="16" height="16" fill="none" aria-hidden="true"><path d="M10 15V5M5 9.5L10 4.5l5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    b.addEventListener('click', function () { (scroller() || window).scrollTo({ top: 0, behavior: 'smooth' }); });
    document.body.appendChild(b);
    var ticking = false;
    /* capture: scroll events from .page-wrapper do not bubble to window */
    document.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        b.classList.toggle('is-on', scrollTop() > window.innerHeight * 1.5);
        ticking = false;
      });
    }, { passive: true, capture: true });
  }

  /* ---------- recently viewed: localStorage au_recent = [handles], newest first ---------- */
  function trackProduct() {
    var meta = document.querySelector('meta[name="au:product-handle"]');
    if (!meta) return;
    var h = meta.getAttribute('content');
    if (!h) return;
    try {
      var list = JSON.parse(localStorage.getItem('au_recent') || '[]');
      if (!Array.isArray(list)) list = [];
      list = [h].concat(list.filter(function (x) { return x !== h; })).slice(0, 12);
      localStorage.setItem('au_recent', JSON.stringify(list));
    } catch (e) {}
  }

  /* ---------- utility row height (the homepage hero slides under it) ---------- */
  function utilityHeight() {
    var u = document.querySelector('.au-utility-section');
    if (!u) return;
    function set() { document.documentElement.style.setProperty('--au-utility-h', u.offsetHeight + 'px'); }
    set();
    window.addEventListener('resize', set, { passive: true });
  }

  function init() {
    utilityHeight();
    watch(document);
    backToTop();
    trackProduct();
    /* re-scan when the theme editor or the section renderer swaps markup */
    document.addEventListener('shopify:section:load', function (e) { watch(e.target); });
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { watch(document); break; }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Card finish dots (snippets/au-card-swatches.liquid + its twin in v12-engine): hover or tap a
   dot to show that finish's photo; the card links then open that variant. Delegated, so cards
   the search engine renders later work too. */
(function () {
  'use strict';
  function pick(dot) {
    var card = dot.closest('.las-card, .au-card');
    if (!card) return;
    card.querySelectorAll('.au-swatch').forEach(function (d) { d.classList.toggle('is-on', d === dot); });
    card.classList.add('is-sw');
    var img = card.querySelector('.las-card__imgwrap img:not(.i2), .au-card__img:not(.au-card__img--2)');
    if (img && dot.dataset.img && img.tagName === 'IMG') { img.removeAttribute('srcset'); img.src = dot.dataset.img; }
    if (dot.dataset.url) card.querySelectorAll('a.las-card__imgwrap, a.las-card__t, a.au-card__media, a.au-card__title').forEach(function (a) { a.href = dot.dataset.url; });
  }
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('.au-swatch');
    if (dot) { e.preventDefault(); pick(dot); }
  });
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var dot = e.target.closest && e.target.closest('.au-swatch');
    if (dot && !dot.classList.contains('is-on')) pick(dot);
  });
})();

/* Smooth expand / collapse, FALLBACK ONLY: browsers with ::details-content animate the rows
   in CSS (snippets/au-design.liquid), which starts on the click frame. Older browsers get the
   same motion here. Horizon accordion rows are left to Horizon's own fallback CSS. */
(function () {
  'use strict';
  if (window.CSS && CSS.supports && CSS.supports('selector(::details-content)')) return;
  var SEL = 'details.au-faq__q, details.au-faqs__item, details.llgh__d, details[data-au-smooth]';
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function slide(d) {
    var start = d.getBoundingClientRect().height;
    if (d._auAnim) d._auAnim.cancel();
    var opening = !d.open || d.classList.contains('is-closing');
    var end;
    if (opening) {
      d.classList.remove('is-closing');
      d.open = true;
      end = d.getBoundingClientRect().height;
    } else {
      d.open = false;
      end = d.getBoundingClientRect().height;
      d.open = true;
      d.classList.add('is-closing');
    }
    d.style.overflow = 'hidden';
    var a = d.animate({ height: [start + 'px', end + 'px'] }, { duration: 360, easing: 'cubic-bezier(.2, .7, .2, 1)' });
    d._auAnim = a;
    a.onfinish = function () {
      d._auAnim = null;
      d.style.overflow = '';
      if (!opening) { d.open = false; d.classList.remove('is-closing'); }
    };
    a.oncancel = function () { d.style.overflow = ''; };
  }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || reduce.matches) return;
    var sum = e.target.closest && e.target.closest('summary');
    if (!sum || e.target.closest('a, button, input, select, textarea')) return;
    var d = sum.parentElement;
    if (!d || d.tagName !== 'DETAILS' || !d.matches(SEL) || typeof d.animate !== 'function') return;
    e.preventDefault();
    slide(d);
  });
})();

/* Running line: a steady ~61 px per second whatever the width (Broadcast's pace). Horizon's marquee
   moves its track by half its width per loop; the duration is that distance divided by the pace. */
(function () {
  'use strict';
  var PACE = 61;
  function tune(m) {
    var w = m.querySelector('.marquee__wrapper');
    if (!w) return;
    var dist = w.scrollWidth / 2;
    if (dist > 0) m.style.setProperty('--au-mq-dur', (dist / PACE).toFixed(2) + 's');
  }
  /* pause while a mouse hovers it or a finger holds it; always resume when the mouse leaves, the finger
     lifts, a scroll starts or the tab comes back (Horizon's own pause could stay stuck on phones) */
  function ramp(m, to) {
    var w = m.querySelector('.marquee__wrapper');
    var a = w && w.getAnimations()[0];
    if (!a) return;
    cancelAnimationFrame(m._auRamp);
    var from = a.playbackRate, t0 = performance.now(), dur = to ? 350 : 250;
    (function step(now) {
      var k = Math.min(1, (now - t0) / dur);
      a.updatePlaybackRate(from + (to - from) * (1 - Math.pow(1 - k, 3)));
      if (k < 1) m._auRamp = requestAnimationFrame(step);
    })(t0);
  }
  function hold(m) {
    var host = m.parentElement;
    if (!host || m._auHold) return;
    m._auHold = true;
    var hover = false;
    var stop = function () { ramp(m, 0); };
    var go = function () { ramp(m, 1); };
    /* a scroll, a tab switch or a page return resume it unless a mouse still rests on it */
    var free = function () { if (!hover) go(); };
    host.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hover = true; stop(); } });
    host.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hover = false; go(); } });
    host.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') stop(); });
    ['pointerup', 'pointercancel', 'touchend', 'touchcancel'].forEach(function (t) { host.addEventListener(t, function (e) { if (!e.pointerType || e.pointerType !== 'mouse') go(); }, { passive: true }); });
    document.addEventListener('pointerup', function (e) { if (e.pointerType !== 'mouse') go(); }, { passive: true });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) free(); });
    window.addEventListener('pageshow', free);
    window.addEventListener('scroll', free, { passive: true, capture: true });
  }
  function scan() {
    document.querySelectorAll('main marquee-component').forEach(function (m) {
      tune(m);
      hold(m);
      if (!m._auMq && 'ResizeObserver' in window) { m._auMq = new ResizeObserver(function () { tune(m); }); m._auMq.observe(m.querySelector('.marquee__wrapper') || m); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  window.addEventListener('load', scan);
  document.addEventListener('shopify:section:load', scan);
})();

/* Popout lists (Broadcast): a <select data-au-pop> inside a [data-au-pop-wrap] gets a calm
   list that fades in under (or above) its toggle button instead of the browser's dropdown.
   The select stays the source of truth: picking a row sets its value and fires "change",
   so forms that submit on change (country, language) and the catalog sort keep working. */
(function () {
  'use strict';
  var uid = 0;
  function build(wrap) {
    if (wrap._auPop) return;
    var sel = wrap.querySelector('select');
    var btn = wrap.querySelector('[data-au-pop-btn]');
    if (!sel || !btn) return;
    wrap._auPop = true;
    var list = document.createElement('ul');
    list.className = 'au-pop';
    list.id = 'au-pop-' + (++uid);
    list.setAttribute('role', 'listbox');
    list.tabIndex = -1;
    if (sel.getAttribute('aria-label')) list.setAttribute('aria-label', sel.getAttribute('aria-label'));
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', list.id);
    function fill() {
      list.innerHTML = '';
      Array.prototype.forEach.call(sel.options, function (o, i) {
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.className = 'au-pop__opt' + (o.selected ? ' is-on' : '');
        li.setAttribute('aria-selected', o.selected ? 'true' : 'false');
        li.dataset.i = i;
        li.tabIndex = -1;
        var sp = document.createElement('span');
        sp.textContent = o.textContent.trim();
        li.appendChild(sp);
        list.appendChild(li);
      });
    }
    fill();
    if (wrap.hasAttribute('data-au-pop-up')) wrap.classList.add('au-pop--up');
    wrap.appendChild(list);
    function open() {
      fill();
      var r = btn.getBoundingClientRect();
      wrap.classList.toggle('au-pop--up', wrap.hasAttribute('data-au-pop-up') || window.innerHeight - r.bottom < 320);
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      var on = list.querySelector('.is-on') || list.firstElementChild;
      if (on) { on.focus({ preventScroll: true }); list.scrollTop = Math.max(0, on.offsetTop - 90); }
      document.addEventListener('pointerdown', outside, true);
    }
    function close(refocus) {
      wrap.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('pointerdown', outside, true);
      if (refocus) btn.focus({ preventScroll: true });
    }
    function outside(e) { if (!wrap.contains(e.target)) close(false); }
    function choose(li) {
      var i = +li.dataset.i;
      close(true);
      if (sel.selectedIndex === i) return;
      sel.selectedIndex = i;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      if (sel.hasAttribute('data-au-pop-submit') && sel.form) sel.form.submit();
    }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (wrap.classList.contains('is-open')) close(false); else open();
    });
    list.addEventListener('click', function (e) { var li = e.target.closest('.au-pop__opt'); if (li) choose(li); });
    list.addEventListener('keydown', function (e) {
      var cur = document.activeElement && document.activeElement.closest ? document.activeElement.closest('.au-pop__opt') : null;
      if (e.key === 'Escape' || e.key === 'Tab') { e.preventDefault(); close(true); return; }
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (cur) choose(cur); return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        var nx = cur ? (e.key === 'ArrowDown' ? cur.nextElementSibling : cur.previousElementSibling) : list.firstElementChild;
        if (nx) nx.focus();
      }
    });
    sel.addEventListener('change', function () { var t = wrap.querySelector('[data-au-pop-text]'); if (t && sel.selectedIndex > -1) t.textContent = sel.options[sel.selectedIndex].textContent.trim(); });
  }
  function scan(root) { (root || document).querySelectorAll('[data-au-pop-wrap]').forEach(build); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
